import { render, staticRenderFns } from "./Datagrid.vue?vue&type=template&id=1c15fde9"
import script from "./Datagrid.vue?vue&type=script&lang=ts"
export * from "./Datagrid.vue?vue&type=script&lang=ts"
import style0 from "./Datagrid.vue?vue&type=style&index=0&id=1c15fde9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports